import { render, staticRenderFns } from "./DiagManagementTutorial.vue?vue&type=template&id=23012d08&"
import script from "./DiagManagementTutorial.vue?vue&type=script&lang=js&"
export * from "./DiagManagementTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports